import { render, staticRenderFns } from "./ToolsList.vue?vue&type=template&id=b8a78816&scoped=true&"
import script from "./ToolsList.vue?vue&type=script&lang=js&"
export * from "./ToolsList.vue?vue&type=script&lang=js&"
import style0 from "./ToolsList.vue?vue&type=style&index=0&id=b8a78816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a78816",
  null
  
)

export default component.exports